import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { NewsletterForm } from './NewsletterForm';

function FooterComponent() {
  const currentYear = new Date().getFullYear();

  return (
    <footer role="contentinfo" aria-label="Site footer" className="border-t">
      <div className="container mx-auto px-4 py-8">
        <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-4">
          <div>
            <h3 className="mb-4 text-lg font-semibold">About</h3>
            <p className="text-muted-foreground">
              Your gateway to engineering excellence and space technology, built in Rocket City.
            </p>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-semibold">Quick Links</h3>
            <nav aria-label="Quick Links">
        <ul className="space-y-2">
                <li>
          <Link to="/blog" className="text-muted-foreground hover:text-primary py-2 inline-block">
                    Blog
                  </Link>
                </li>
                <li>
          <Link to="/toolkit" className="text-muted-foreground hover:text-primary py-2 inline-block">
                    Engineering Toolkit
                  </Link>
                </li>
                <li>
          <Link to="/merch" className="text-muted-foreground hover:text-primary py-2 inline-block">
                    Merch Store
                  </Link>
                </li>
                <li>
                  <Link to="/subscribe" className="text-muted-foreground hover:text-primary py-2 inline-block">
                    Subscribe
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-semibold">Connect</h3>
            <nav aria-label="Social Links">
              <ul className="space-y-2">
                <li>
                  <Link to="/contact" className="text-muted-foreground hover:text-primary py-2 inline-block">
                    Contact Us
                  </Link>
                </li>
                <li>
                  <a
                    href="https://twitter.com/rocketcitynerd"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-muted-foreground hover:text-primary py-2 inline-block"
                  >
                    Twitter
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/rocketcitynerd"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-muted-foreground hover:text-primary py-2 inline-block"
                  >
                    GitHub
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          <div>
            <section aria-labelledby="newsletter-heading">
              <h3 id="newsletter-heading" className="mb-4 text-lg font-semibold">Newsletter</h3>
              <p className="mb-4 text-muted-foreground">
                Subscribe to get updates on new content and features.
              </p>
              <NewsletterForm />
            </section>
          </div>
        </div>

        <div className="mt-8 border-t pt-8 text-center text-sm text-muted-foreground">
          <p>© {currentYear} Rocket City Nerd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export const Footer = memo(FooterComponent);
